import React from 'react';

import UDFormCheckbox from 'ud-form/components/checkbox';
import UDText from 'ud-ui/components/text';
import TooltipWrapper from './tooltip-wrapper';
import { TooltipPosition, TooltipProps } from './types';

interface LabeledCheckboxProps extends TooltipProps {
  label: string;
  name: string;
  containerClassName?: string;
  disabled?: boolean;
}

const LabeledCheckbox: React.FC<LabeledCheckboxProps> = ({
  label,
  name,
  containerClassName = 'd-flex align-items-center mb-4',
  tooltip,
  tooltipProps,
  disabled = false,
}) => {
  const tooltipPosition = tooltipProps?.position || 'right';

  const renderTooltip = (position: TooltipPosition) => (
    <TooltipWrapper tooltip={tooltip} tooltipProps={{ ...tooltipProps, position }} position={position} />
  );

  return (
    <div className={containerClassName}>
      <div className="d-flex align-items-center justify-content-between w-100 min-h-10">
        <div className="d-flex align-items-center mr-2">
          {tooltipPosition === 'left' && renderTooltip('left')}
          <UDText type="callout" className="color-SurfaceRaisinBlack50">
            {label}
          </UDText>
          {tooltipPosition === 'right' && renderTooltip('right')}
        </div>
        <div className="d-flex align-items-center">
          {tooltipPosition === 'input-left' && renderTooltip('input-left')}
          <UDFormCheckbox name={name} disabled={disabled} />
          {tooltipPosition === 'input-right' && renderTooltip('input-right')}
        </div>
      </div>
    </div>
  );
};

export default LabeledCheckbox;
